<template>
    <div class="l-body">
        <div class="l-menu" @click="handleClick">{{name}}</div>
    </div>
</template>

<script>
export default {
    name: 'aside-button',
    props: {
        name: {
            type: String,
            default: '按钮'
        }
    },
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
}
</script>

<style scoped>
.l-body {
    position: relative;
}

.l-menu {
    text-align: center;
    width: 118px;
    height: 73px;
    cursor: pointer;
    line-height: 69px;
    font-size: 14px;
    box-sizing: border-box;
    color: #FFFFFF;
    font-weight: bold;
    z-index: 3;
    background: url('../images/menu-bg.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 5px;
}
</style>